<template>
  <div class="jump-gooddetail">
    <div class="jump-header">
      <van-row class="jump-gooddetail-navbar">
        <van-col span="3" class="jump-gooddetail-navbar-arrow">
          <van-icon name="arrow-left" @click="back" />
        </van-col>
        <van-col span="18" class="navbar-items">
          <a href="javascript:;" class="active">{{good.gcId=='66279'?'专家':'商品'}}</a>
          <a href="javascript:;" to="evaluate" v-if="good.gcId!='66279'">评价</a>
          <a href="javascript:;" to="detail">{{good.gcId=='66279'?'课程介绍':'详情'}}</a>
          <a
            href="javascript:;"
            :href="'#/goodInquiry?goodsId='+goodsId+'&gcId='+good.gcId"
          >{{good.gcId=='66279'?'咨询记录':'咨询'}}</a>
        </van-col>
        <van-col span="3" class="jump-gooddetail-navbar-arrow"></van-col>
      </van-row>
    </div>
    <van-swipe class="jump-gooddetail-swipe" :autoplay="3000">
      <van-swipe-item v-for="gimg in goodImgs">
        <img v-lazy="gimg.picUrl" />
      </van-swipe-item>
    </van-swipe>
    <van-row class="detail-header" type="flex" v-if="good.gcId!='66279'">
      <van-col span="20">
        <h4>
          <span></span>
          {{good.showPrice | priceFmt}}
        </h4>
        <p>
          <span>原价:</span>
          <span style="text-decoration:line-through">{{good.showMarketPrice | priceFmt}}</span>
        </p>
        <p>
          <span>库存:</span>
          {{good.goodsInventory}}
        </p>
        <p>
          <span>单位:</span>
          {{good.goodsUnitSeller}}
        </p>
        <h5><span v-if="good.combinationsNumber&&good.combinationsNumber>0" style="color:red">(组合商品)</span>{{good.goodsName}}</h5>
      </van-col>
      <van-col span="2" class="text-right">
        <i class="iconfont icon-shoucang" ref="goods" @click="shoucang"></i>
      </van-col>
      <van-col span="2" class="text-right">
        <i class="iconfont icon-fenxiang detail-share" @click="sharedInfo"></i>
      </van-col>
      <van-popup v-model="show2" position="bottom">
        <van-row>
					<van-col span="24">						
						<div style="display: inline-block;vertical-align: top;margin: 20px 20px;" @click="sharedSession">
							<div style="width: 64px;height: 64px;border-radius: 50%;overflow: hidden;background:#dfdfdf;">
								<img src="../assets/img/share_wechart.png" style="width: 80% !important;margin:10%;">
							</div>
							<div style="width: 64px;height: 20px;line-height:20px;text-align:center;margin: 5px auto;">微信</div>
						</div>			
						<div style="display: inline-block;vertical-align: top;margin: 20px 20px;" @click="shareTimeLine">
							<div style="width: 64px;height: 64px;border-radius: 50%;overflow: hidden;background:#dfdfdf;">
								<img src="../assets/img/share_friends.png" style="width: 80% !important;margin:10%;">
							</div>
							<div style="width: 64px;height: 20px;line-height:20px;text-align:center;margin: 5px auto;">朋友圈</div>
						</div>
					</van-col>
        </van-row>
      </van-popup>
    </van-row>
    <!-- <div class="detail-active" v-if="good.goodsType==6">
      <van-row>
        <van-col span="8">
          <span>支付方式</span>
        </van-col>
        <van-col span="16">
          <van-radio-group v-model="payMent">
            <van-cell-group>
              <van-radio name="1" @click="getPayMent(1)" style="float: left">现金</van-radio>
              <van-radio name="2" @click="getPayMent(2)" style="float: left;margin-left: 20px">账期</van-radio>
            </van-cell-group>
          </van-radio-group>
        </van-col>
      </van-row>
    </div> -->
    <!-- 参数查看 -->
    <div class="detail-active" v-if="mainData.length>0||attrs.length>0">
      <van-row style="margin-bottom:10px" v-if="mainData.length>0">
        <van-col span="6" style="font-size:14px;color:#555;">参数详情：</van-col>
        <van-col span="18" @click.native="showMain=true" style="color:#f5a623;font-size:14px;">点击查看</van-col>
      </van-row>

      <van-row v-if="attrs.length>0">
        <van-col span="6" style="font-size:14px;color:#555;">规格选择：</van-col>
        <van-col
          span="18"
          @click.native="choiceSpec"
          style="color:#f5a623;font-size:14px;"
        >{{defaultSpec.length>0?'已选 '+ originSelected:'选择 '+attrMsg}}</van-col>
      </van-row>
    </div>
    <div class="detail-active" v-if="good.gcId!='66279'">
      <van-row>
        <van-col span="24">
          <!-- <p><span>发货:</span>河南洛阳</p> -->
        </van-col>
      </van-row>
      <van-row>
        <van-col span="18">
          <p v-if="canIntegral == 0">
            <span>优惠:</span>暂无积分赠送
          </p>
          <p v-else>
            <span>优惠:</span>
            购买可得{{canIntegral}}积分
          </p>
        </van-col>
        <van-col span="6" class="text-right">
          <!-- <p>查看<van-icon name="arrow"/></p> -->
        </van-col>
      </van-row>
      <van-row>
        <van-col span="18" v-if="promotions.length>0">
          <!-- <p><span>活动:</span>限时促销</p> -->
          <van-field
            readonly
            clickable
            label="活动:"
            :value="activity"
            placeholder="促销活动"
            @click="showPicker = true"
          />

          <van-popup v-model="showPicker" position="bottom">
            <!-- <van-picker
                          show-toolbar
                          :columns="columns"
                          @cancel="showPicker = false"
                          @confirm="onConfirm"
            />-->
            <ul class="activityContent" v-if="promotions.length == 0">
              <li>暂无促销活动</li>
            </ul>
            <ul class="activityContent" v-else v-for="(item, index) in promotions" :key="index">
              <li>{{index+1}}. {{item}}</li>
            </ul>
          </van-popup>
        </van-col>
        <!-- <van-col span="6" class="text-right">
                     <p>活动详情
                         <van-icon name="arrow"/>
                     </p>
        </van-col>-->
      </van-row>
    </div>
    <div class="detail-comment" id="evaluate" v-if="good.gcId!='66279'">
      <van-row>
        <van-col span="18">
          <h5>产品评论({{total}})</h5>
        </van-col>
        <van-col span="6">
          <a :href="'#/goodEvaluation?goodsId='+goodsId">
            <p class="comment-more">
              查看全部
              <van-icon name="arrow" />
            </p>
          </a>
        </van-col>
      </van-row>

      <!-- <p class="comment-tag">
                 &lt;!&ndash; active &ndash;&gt;
                 <span :class="evaluateActive[0]" @click="goodsEvaluation(0)">全部</span>
                 <span v-for="item in evaluateTypeList" :class="evaluateActive[item.id]"
                       @click="goodsEvaluation(item.id)">
                     {{item.dictdataValue}}
                 </span>
      </p>-->
      <div class="comment-item" v-for="(item, index) in commentList" :key="index">
        <van-row>
          <van-col span="12">
            <p>
              <!-- <img src="../assets/logo.png" width="25"> -->
              昵称：{{item.userName}}
            </p>
          </van-col>
          <van-col span="12" class="text-right">
            <p>{{item.createtime}}</p>
          </van-col>
        </van-row>
        <p>评价内容：{{item.evaluateInfo}}</p>
      </div>
    </div>

    <div class="detail-info" v-if="good.gcId=='66279'">
      <h5>专家信息</h5>
      <van-row>
        <van-col span="5">
          <p>
            <span>专家姓名:</span>
          </p>
        </van-col>
        <van-col span="19">
          <p>{{good.goodsName}}</p>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="5">
          <p>
            <span>专家简历:</span>
          </p>
        </van-col>
        <van-col span="19">
          <p>{{good.specificationDescription}}</p>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="5">
          <p>
            <span>擅长领域:</span>
          </p>
        </van-col>
        <van-col span="19">
          <p>{{good.seoKeywords}}</p>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="10">
          <p>服务案例和效果提升:</p>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="24">
          <p>{{good.seoDescription}}</p>
        </van-col>
      </van-row>
    </div>
    <div class="detail-info" v-else>
      <h5>产品信息</h5>
      <van-row>
        <van-col span="5">
          <p>
            <span>产品名称:</span>
          </p>
        </van-col>
        <van-col span="19">
          <p>{{good.goodsName}}</p>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="5">
          <p>
            <span>产品描述:</span>
          </p>
        </van-col>
        <van-col span="19">
          <p>{{good.seoDescription}}</p>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="5">
          <p>
            <span>产品类型:</span>
          </p>
        </van-col>
        <van-col span="19">
          <p v-if="good.specificationDescription == ''">暂无类型描述</p>
          <p v-else>{{good.specificationDescription}}</p>
        </van-col>
      </van-row>
    </div>
    <div class="detail-show" id="detail">
      <h5 v-if="good.gcId=='66279'">专家详情</h5>
      <h5 v-else>产品详情展示</h5>
      <div v-html="good.goodsDetails" id='expertInfo'></div>
    </div>

    <van-goods-action v-if="good.gcId=='66279'">
      <van-goods-action-mini-btn
        icon="wap-home"
        icon-class="iconfont icon-shouye"
        text="首页"
        to="/"
        style="width:33%"
      />
      <van-goods-action-mini-btn
        icon="chat-o"
        icon-class="iconfont icon-zixun"
        text="咨询"
        @click="goodsConsultSave"
        style="width:33%"
      />
      <van-goods-action-mini-btn style="width:33%">
        <i class="iconfont icon-shoucang" ref="store" @click="storeSel"></i>
        收藏
      </van-goods-action-mini-btn>
    </van-goods-action>

    <van-goods-action v-else>
      <van-goods-action-mini-btn
        icon="wap-home"
        icon-class="iconfont icon-shouye"
        text="首页"
        to="/"
      />
      <van-goods-action-mini-btn
        icon="chat-o"
        icon-class="iconfont icon-zixun"
        text="咨询"
        @click="goodsConsultSave"
      />
      <!-- <van-goods-action-mini-btn
                @click="storeCol"
                ref="store"
                icon="star-o"
                icon-class="iconfont icon-collection"
                text="收藏"
      />-->
      <van-goods-action-mini-btn>
        <i class="iconfont icon-shoucang" ref="store" @click="storeSel"></i>
        收藏
      </van-goods-action-mini-btn>
      <van-goods-action-big-btn text="加入购物车" class="btn-cart" @click="addCartBuy('1')" />
      <van-goods-action-big-btn text="立即购买" class="btn-buy" @click="addCartBuy('2')" />
    </van-goods-action>

    <van-dialog
      v-model="goodsConsult"
      :title="good.gcId=='66279'?'我要咨询':'商品咨询'"
      show-cancel-button
      @confirm="goodsConsultadd"
    >
      <van-field
        type="textarea"
        placeholder="请输入您要咨询的内容"
        v-model="goodsConsultContent"
        style="padding: 10px 20px"
      />
      <van-row style="padding-left:20px" v-if="securityCodeConsult">
        <span>验证码：</span>
        <input
          type="text"
          style="display:inline-block;width:100px;border:1px solid #ccc;height:30px;"
          v-model="code"
        />
        <img :src="imgSrc" @click="changeSrc" style="margin:10px 20px" />
      </van-row>
    </van-dialog>
    <BackTop />

    <!-- 商品的规格 -->
    <!-- <van-sku v-model="showSku" :sku="sku" :goods="goods"
    @buy-clicked="onBuyClicked" :goods-id="goodsId" @add-cart="onAddCartClicked" :initial-sku="initialSku" :hide-stock="sku.hide_stock"/>-->
    <!-- 打电话的悬浮框 -->
    <div class="phoneBox" v-show="showPhone" @click="callPhone">
      <van-icon name="close" class="close" color="red" size="18px" @click.stop="showPhone=false" />
      <van-icon name="phone" size="22px" color="#fff" />
      <p>电话咨询</p>
    </div>
    <!-- 产品规格面板开始 -->
    <van-popup v-model="showPenal" position="bottom" class="attrBox" :style="{ maxHeight: '80%' }" :close-on-click-overlay="false">
      <div class="titleBoxs">
        <span class="closeBox" @click="closeSku">
          <van-icon class="icon" name="close" />
        </span>

        <div class="imgCont">
          <img :src="imgCover" />
        </div>
        <div class="sRight">
          <p class="price">
            <span>{{goodsPrice | priceFmt}}</span>
          </p>
          <p>原价：{{orgPrice | priceFmt}}</p>
          <p>单位：{{skuDan}}</p>
          <p>库存：{{surplus}}</p>
          <p v-show="checkData.length!=attrs.length">选择：{{choice}}</p>
          <!-- <p v-show="checkData.length==attrs.length">已选：{{selected}}</p> -->
        </div>
      </div>
      <div class="sizeBox">
        <div class="item" v-for="(item,index) in attrs" :key="index">
          <h3>{{item.name}}</h3>
          <ul>
            <li
              v-for="(obj,i) in item.entries"
              :key="i"
              :class="{'activeLi':obj.isChecked,'disLi':(index==wIndex&&i==nIndex&&isStop)}"
              @click="clickItem(index,i,obj.id,obj.value,item.attrId)"
            >{{obj.value}}</li>
          </ul>
        </div>
        <!-- enablePaymentDay为1  -->
         <div class="item" v-if="good.enablePaymentDay==1&&paymentList.length!=0">
          <h3>账期</h3>
          <ul>
            <li v-for="(item,i) of paymentList" :key="i" :class="{'activeLi':i==payIndex}" @click="changePay(i)">
               {{item.codeChineName}}
            </li>
            <!-- <li  :class="{'activeLi':enablePackType=='bagAmount'}"   @click="changePack('0')"></li>
             <li :class="{'activeLi':enablePackType=='bulkAmount'}"  @click="changePack('1')">散装</li> -->
          </ul>
        </div>
        <!-- enablePackType为1启用包装 -->
        <div class="item" v-if="good.enablePackType==1">
          <h3>包装</h3>
          <ul>
            <li  :class="{'activeLi':enablePackType=='bagAmount'}"   @click="changePack('0')">袋装</li>
             <li :class="{'activeLi':enablePackType=='bulkAmount'}"  @click="changePack('1')">散装</li>
          </ul>
        </div>

        <div class="item" style="color:red;font-size:15px">
          <span v-if="(enablePresell==1&&surplus==0)||(enablePresell==1&&isyuSale)">预售
          <span v-if="presellDate">(预计{{presellDate}}日发货)</span>
           </span>
        </div>
      </div>

    <div class="remarkCont" v-if="remark&&remark!=''">
        <p>备注：{{remark}}</p>
      </div>

      <div class="countBox">
        <div class="leftBox">
          <h3>购买数量：</h3>
          <span>最小起购数量为：{{minCount}}{{this.skuDan}}</span>
        </div>
        <div class="rightBox">
          <van-stepper v-if="good.combinationsNumber&&good.combinationsNumber>0"
             input-width="50px"
            v-model="count"
            :min="minCount"
            disabled>

          </van-stepper>
          <van-stepper v-else
            input-width="50px"
            v-model="count"
            :min="minCount"
            @change="onChangeEdit"
            async-change
          />
        </div>
      </div>
      <div class="btns" v-if="isTabbar">
        <van-button type="warning" @click="goodSave">确定</van-button>
      </div>

      <div class="btnT" v-else>
        <van-button class="btn1" @click="goodSave('1')">加入购物车</van-button>
        <van-button class="btn2" @click="goodSave">立即购买</van-button>
      </div>
    </van-popup>
    <!-- 主体参数的 -->
    <van-popup v-model="showMain" position="bottom" class="guiBox" :style="{ maxHeight: '80%' }">
      <!-- <van-icon class="icon" name="close" @click.native="showMain =false" size="20" /> -->
      <span class="closeBox" @click="showMain =false">
        <van-icon class="icon" name="close" />
      </span>

      <div v-for="item in mainData">
        <h5>{{item.group}}</h5>
        <van-row class="can-item" v-for="obj in  item.entries">
          <van-col span="8" class="can-t">{{obj.name}}</van-col>
          <van-col span="16" class="can-v">{{obj.value}}</van-col>
        </van-row>
      </div>
    </van-popup>
  </div>
</template>
<script>
  let shares = {};
  if (window.plus) {
    plusReady();
  } else {
    document.addEventListener("plusready", plusReady, false);
  }
  function plusReady() {
    plus.share.getServices(
            function(s) {
              let shareObj = {};
              for (var i in s) {
                var t = s[i];
                shareObj[t.id] = t;
              }
              shares = shareObj;
            },
            function(e) {}
    );
  }
import {
  NavBar,
  Swipe,
  SwipeItem,
  GoodsAction,
  GoodsActionBigBtn,
  GoodsActionMiniBtn,
  Row,
  Col,
  Tab,
  Tabs,
  Field,
  Popup,
  Picker,
  Dialog,
  Button,
  RadioGroup,
  Radio,
  CellGroup,
  Sku,
  Cell,
  Stepper
} from "vant";
import $ from "jquery";

export default {
  name: "gooddetail",
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [NavBar.name]: NavBar,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionBigBtn.name]: GoodsActionBigBtn,
    [GoodsActionMiniBtn.name]: GoodsActionMiniBtn,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Sku.name]: Sku,
    [Picker.name]: Picker,
    [Stepper.name]: Stepper
  },
  data() {
    return {
      presellDate:'',//预计几号发货 不是预售不返回
      enablePresell:0,//是否启用账期
      goodsInventory:0,//库存
      imgCover: "", //sku的图片
      originSelected:'',
      paymentList:[],
      payIndex:0,
      count: 1, //购买数量
      minCount: 1, //最小起购数量
      goodsPrice: 100, //价格
      orgPrice: 100, //原价
      surplus: 6, //剩余
      selected: "", //已选
      attrMsg: "", //
      choice: "", //选择提示
      enableAllSpec: [], //初始化所有没有启用的项
      enableSpec:[],//点击时没启动的项
      showPenal: false, //商品规格
      showMain: false, //主体参数
      attrs: [], //规格
      checkData: [], //选中的规格数组
      wIndex: -1,
      nIndex: -1,
      isAddCart: false,
      isTabbar: false,
      mainData: [],
      defaultCode: "", //默认规格码
      defaultSpec: [], //默认规格
      skuCode: "", //规格码
      skuDan:'',//sku单位
      imgSrc: this.$api.root + this.jumuc.verify,
      securityCodeConsult: false, //咨询时验证码，true显示
      code: "", //验证码
      goodsConsult: false,
      goodsConsultContent: "",
      goodsId: 0,
      good: {},
      store: {},
      goodImgs: [],
      evaluateCount: 0,
      consultCount: 0,
      specificationDescription: "",
      commentList: [],
      active: 0,
      canIntegral: "",
      promotions: [],
      activity: "",
      showPicker: false,
      show2: false,
      evaluateTypeList: [],
      evaluateActive: [],
      total: 0,
      isStop:false,
      // payMentpayMent: "2",
      showSku: false,
      showPhone: true,
      specList:[],
          remark:'',//规格页面的备注
     oldRemark:'',
     enablePackType:'bagAmount',//默认选中袋装
      goods: {
        title: "测试商品",
        // 默认商品 sku 缩略图
        picture:
          "http://jumuc.com//upload/store/1/2019/05/30/b6dd7db0-802b-4f53-8e20-c8e1c8ea45a6.png"
      },
      isyuSale:false

    };
  },
  // inject: ['reload'],
  beforeCreate() {
    this.integralStore = eval(localStorage.getItem("integralStore"));
    // if (!that.$api.isLogin()) {
    //     location.href = '#/login'
    //     return;
    // }
  },
  mounted() {
    //分享成功，失败的回调
    window.shareGetIntegral = this.shareGetIntegral;
    window.shareFail = this.shareFail;
    this.scrollfixed();
    this.getData();
  },
  watch:{
 $route (to,form){
       //分享成功，失败的回调
    window.shareGetIntegral = this.shareGetIntegral;
    window.shareFail = this.shareFail;
    this.scrollfixed();
    this.getData();
 }
  },
  methods: {
      forwardGetIntegral(){
          let that = this;
          that.$api.get(that.jumuc.integral.forward,{
                  userId:localStorage.getItem("userId"),
                  source:2
          },
          successRes=>{
              if(successRes.success){
                  that.$toast("转发成功,您获得"+successRes.data.integral+"积分")
              }else{
                  that.$toast(successRes.msg);
              }
          })
      },
    getData (){
      let that=this;
      this.goodsId = this.$route.params.goodsId;
    //商品详情
    this.$api.get(this.jumuc.goods + this.goodsId, {}, successRes => {
      if (successRes.success) {
        // 商品是否收藏
        if (successRes.data.isGoodsCollect) {
          that.$refs.goods.style.color = "#d0021b";
        } else {
          that.$refs.goods.style.color = "#333";
        }
        // 店铺是否收藏
        if (successRes.data.isStoreCollect) {
          that.$refs.store.style.color = "#d0021b";
        } else {
          that.$refs.store.style.color = "#888";
        }
        that.good = successRes.data.goods;
        that.goodImgs = successRes.data.picList;
        that.imgCover = that.goodImgs[0]["picUrl"];
        that.store = successRes.data.store;
        this.paymentList=successRes.data.paymentList;
        // 优惠赠送积分
        that.canIntegral = successRes.data.canIntegral;
        //预计几日发货
        that.presellDate=successRes.data.presellDate;
        that.enablePresell=successRes.data.goods.enablePresell;
        // 促销活动
        that.promotions = successRes.data.promotions;
        // 评价列表
        that.evaluateCount = successRes.data.evaluateCount;
        that.specificationDescription = that.good.specificationDescription;
        that.consultCount = successRes.data.consultCount;
        //咨询时的验证码
        that.securityCodeConsult = successRes.data.securityCodeConsult;
          this.oldRemark=successRes.data.goodsDefaultSku.remark;
        this.remark=successRes.data.goodsDefaultSku.remark;

        //起购数量与 现价,原价
        if(this.good.combinationsNumber&&this.good.combinationsNumber>0){
             this.minCount =
          successRes.data.goods.combinationsNumber;
            this.count= this.minCount ;
        }else{
             this.minCount =
          successRes.data.goods.purchaseQuantity == 0
            ? 1
            : successRes.data.goods.purchaseQuantity;
            this.count= this.minCount ;
        }

        this.goodsPrice = successRes.data.goods.showPrice;
        (this.orgPrice = successRes.data.goods.showMarketPrice),
          //商品参数 ，规格,库存
          (this.mainData = JSON.parse(successRes.data.goods.param));
          this.specList=JSON.parse(successRes.data.goods.spec);
        this.attrs = JSON.parse(successRes.data.goods.spec);
        this.surplus = successRes.data.goods.goodsInventory;
        //默认 规格码，规格,禁用的sku
        this.defaultCode = successRes.data.goodsDefaultSku.code;
        this.skuCode = this.defaultCode;
         //this.enableAllSpec=successRes.data.enableList;
         this.enableAllSpec=successRes.data.enableList;
        this.defaultSpec = JSON.parse(successRes.data.goodsDefaultSku.spec);
        if (this.attrs.length > 0) {
          this.getInit('1');
        }
      } else {
        this.$toast(successRes.msg);
      }
    });

    // 商品评价详情
    this.$api.post(
      this.jumuc.goodsEvaluation,
      { goodsId: this.goodsId, currentPage: 1, pageSize: 2 },
      successRes => {
        if (successRes.success) {
          that.commentList = successRes.data.commentList.list;
          that.total = successRes.data.commentList.total;
        }
      }
    );
    // 获取订单评价类型
    this.$api.get(this.jumuc.order.getEvaluateType, null, successRes => {
      if (successRes.success) {
        that.evaluateTypeList = successRes.data;
        that.evaluateActive[0] = "active";
      }
    });
    },
    changePack (type){//袋装切换
         this.enablePackType=type==0?'bagAmount':'bulkAmount';
         this.getPriceInfo(this.checkData);
    },
    changePay (i){//账期的切换
       this.payIndex=i;
       this.getPriceInfo(this.checkData);
    },
    getInit(type) {
      //处理数据 筛选出isSelected为true的项
      this.attrs=this.specList;
      var newArray = [];
      for (var i = 0; i < this.attrs.length; i++) {
        var items = this.attrs[i]["entries"];
        newArray = items.filter(item => item.isSelected == true);
        this.$set(this.attrs[i], "entries", newArray);
      }
      this.attrs = this.attrs.filter(item => item.entries.length > 0);
        //禁用的
        var disSpec=this.enableAllSpec;
      var disArr=[];
      for (var n = 0; n < disSpec.length; n++) {
         var specs=JSON.parse(disSpec[n]);
         disArr[n]=(specs.map(item=>item.value)).join(' - ');
      }
      this.enableSpec=disArr;

      //判断是否有默认选中的规格
      var choiceArrName = this.attrs.map(item => item.name);
      if (this.defaultSpec.length > 0) {
        var choiceArrVal = this.defaultSpec.map(item => item.value);
        if(type==1){//初始化
             this.selected = choiceArrVal.join(" - ");
              this.originSelected= this.selected;
             if(this.good.enablePaymentDay==1&&this.paymentList.length!=0){//启用账期
                this.originSelected+=' - '+this.paymentList[0]["codeChineName"]
              }
              if(this.good.enablePackType==1){//启用袋装
                this.originSelected+=' - 袋装';
              }

        }

        for (var n = 0; n < this.attrs.length; n++) {
          for (var k = 0; k < this.attrs[n]["entries"].length; k++) {
            if (this.defaultSpec[n].id == this.attrs[n]["entries"][k]["id"]) {
              this.checkData[n] = {
                 attrId:this.defaultSpec[n].attrId,
                id: this.defaultSpec[n].id+"",
                value: this.defaultSpec[n].value,

              };
              this.attrs[n]["entries"][k]["isChecked"] = true;
              this.$set(this.attrs[n], "entries", this.attrs[n]["entries"]);
              break;
            }
          }
        }
      } else {
        this.choice = choiceArrName.join(" ");
      }
      this.attrMsg = choiceArrName.join(" ");
    },
    isCheckDis (str,wIndex,nIndex,id,value,attrId){
      this.isStop=false;
      //循环 禁用的sku项
       this.wIndex = wIndex;
        this.nIndex = nIndex;
      if(this.enableSpec.indexOf(str)==-1){//此组合能选
        var arr = this.attrs[wIndex]["entries"];
        for (var i = 0; i < arr.length; i++) {
          arr[i]["isChecked"] = i == nIndex ? true : false;
          arr.splice(i, 1, arr[i]);
        }
        //拼保存时选中的规格
        this.checkData[wIndex] = {attrId:attrId, id: id + "", value: value };
        this.getPriceInfo(this.checkData);
      }else{
        this.isStop=true;
      }
    },
    clickItem(wIndex, nIndex, id, value,attrId) {
       this.getSelected();
      // //拼保存时选中的规格
      this.checkData[wIndex] = {attrId:attrId, id: id + "", value: value };
      this.checkData = this.checkData.filter(
        item => Object.keys(item).length > 0
      );
        //拼接已选中的规格 selected
         this.selected = this.checkData.map(item => item.value).join(" - ");
        this.isCheckDis(this.selected,wIndex,nIndex,id,value,attrId);
    },
    getSelected (){
      this.checkData=[];
      for(var n=0;n<this.attrs.length;n++){
         var arr=this.attrs[n]["entries"];
          for (var i = 0; i < arr.length; i++) {
            if(arr[i]["isChecked"]){
               this.checkData[n]={
                   attrId:this.attrs[n].attrId,
                  id:arr[i].id+"",//modify by lanshan 数据库存的是字符串，拼接匹配时，应转成字符串
                  value: arr[i].value,
               }
            }
        }
      }

    },
    closeSku (){
        var arr= this.defaultSpec.map(item => item.value);
        this.selected=arr.join('-');
        this.skuDan=this.good.goodsUnitSeller;
        this.showPenal =false;
        for(var i=0;i<this.attrs.length;i++){
          var item=this.attrs[i];
          for(var k=0;k<item.entries.length;k++){
                item.entries[k]["isChecked"]=false;
          }
        }
    },
    getPriceInfo(attrData) {
      this.isyuSale=false;
      //获取价格,库存等信息
      const params = {
        goods_id: this.goodsId,
        selectAll: JSON.stringify(attrData),
        selectPackType:this.good.enablePackType==1?this.enablePackType:'',
        selectPayMentType: this.good.enablePaymentDay==1&&this.paymentList.length!=0?this.paymentList[this.payIndex]["id"]:''
      };
      // if (this.good.goodsType == 6) {
      //   //贸易商品 传支付方式payMent
      //   params["payMent"] = this.payMent;
      // }
      let that=this;
      this.$api.post(this.jumuc.getGoodsPrice, params, successRes => {
        if (successRes.success) {
          if(successRes.data.imgs){
            let imgs=successRes.data.imgs.split(",");
            that.goodImgs=new Array();
            imgs.forEach((img)=>{
              let item=new Object();
              item.picUrl=img;
              that.goodImgs.push(item);
            })
          }
          if(successRes.data.content){
             this.good.goodsDetail=successRes.data.content;
          }
          this.skuDan=successRes.data.goodsUnitSeller;
          this.presellDate=successRes.data.presellDate;
          this.surplus =
            successRes.data.skuStock == null ? 0 : successRes.data.skuStock;
          this.goodsPrice =
            successRes.data.price == null ? "已售罄" : successRes.data.price;
          this.orgPrice =
            successRes.data.marketPrice == null
              ? "已售罄"
              : successRes.data.marketPrice;
                this.remark=successRes.data.remark;
          this.skuCode = successRes.data.skuCode;
          this.minCount =
            successRes.data.purchaseQuantity == 0
              ? 1
              : successRes.data.purchaseQuantity; //起购量
            this.count =this.minCount;
        } else {
          this.$toast(successRes.msg);
        }
      });
    },
    onChangeEdit(value) {
      //判断购买数量大于 库存 显示出来预售
      this.isyuSale=false;
        if(value>this.surplus){
          this.isyuSale=true;
        }
      //购买数量的改变处
      if (value < this.minCount) {
        this.$toast("该商品的最小起购数量为" + this.minCount);
      }
    },
    goodSave(type) {
      //判断是不是组合商品
      if(this.good.combinationsNumber&&this.good.combinationsNumber>0){
         this.count=this.good.combinationsNumber;
      }
      //选规格后的确定，加入购物车中
      if (this.checkData.length != this.attrs.length) {
        this.$toast("请选择商品属性！");
        return false;
      }
      if (this.goodsPrice == "已售罄"||this.goodsPrice == 0) {
        this.$toast("不能购买该商品");
        return false;
      }
      if(this.good.enablePaymentDay==1&&this.paymentList.length!=0){//启用账期
        this.selected+=' - '+this.paymentList[this.payIndex]["codeChineName"]
      }
      if(this.good.enablePackType==1){//启用袋装
        this.selected+=this.enablePackType=='bagAmount'?' - 袋装':' - 散装'
      }
      this.$api.addCart(
        this.goodsId,
        this.count,
        this.selected,
        this.skuCode,
        this.good.enablePackType==1?this.enablePackType:'',
        this.good.enablePaymentDay==1&&this.paymentList.length!=0?this.paymentList[this.payIndex]["id"]:'',
        successRes => {
          if (successRes.success) {
            if (this.isAddCart || type == "1") {
              this.$toast(successRes.msg);
              this.showPenal = false;
            } else {
              location.href = "#/cart";
            }
          } else {
            this.$toast(successRes.msg);
          }
        }
      );
      this.closeSku();
    },
    addCartBuy(type) {
      //tabbar的加入购物车和立即购买
      this.isTabbar = true;
      this.isAddCart = type == "1" ? true : false;
      if (this.attrs.length > 0) {
        this.showPenal = true;
        this.enablePackType='bagAmount';
        this.payIndex=0;
        this.getInit();
         if (this.checkData.length == this.attrs.length) {
          this.getPriceInfo(this.checkData);
       }
      } else {
        if (this.good.showPrice == "null"||this.good.showPrice ==null||this.good.showPrice==0) {
          this.$toast("不能购买该商品");
          return false;
        }
         //判断是不是组合商品
      if(this.good.combinationsNumber&&this.good.combinationsNumber>0){
         this.count=this.good.combinationsNumber;
      }

        this.$api.addCart(
          this.goodsId,
          this.count,
          "",
          "",
          "",
          "",
          successRes => {
            if (successRes.success) {
              if (type == "1") {
                this.$toast(successRes.msg);
              } else {
                location.href = "#/cart";
              }
            } else {
              this.$toast(successRes.msg);
            }
          }
        );
      }
    },
    choiceSpec() {
      //规格选择
      this.showPenal = true;
      this.isTabbar = false;
      this.orgPrice=this.good.showMarketPrice;
      this.skuDan=this.good.goodsUnitSeller;
      this.surplus=this.good.goodsInventory;
      this.goodsPrice=this.good.showPrice;
        this.enablePackType='bagAmount';
        this.payIndex=0;
        this.remark=this.oldRemark;
       this.getInit();
    },

    changeSrc() {
      this.imgSrc =
        this.$api.root + this.jumuc.verify + "?id=" + new Date().getTime();
    },

    shareTimeLine() {
      //分享到朋友圈
      // ios 安卓
      if (navigator.userAgent.match(/android/i)) {
        //安卓
        this.AndroidFriends();
      } else {
        //ios
        let data = [
          "http://wx.jumuc.com/#/gooddetail/" + this.goodsId,
          this.good.goodsName,
          this.good.seoDescription,
          this.goodImgs[0].picUrl
        ];
        window.webkit.messageHandlers.shareFriends.postMessage(data);
      }
    },
    sharedSession() {
      // ios 安卓
      if (navigator.userAgent.match(/android/i)) {
        //安卓
        this.AndroidFriends();
      } else {
        //ios
        let data = [
          "http://wx.jumuc.com/#/gooddetail/" + this.goodsId,
          this.good.goodsName,
          this.good.seoDescription,
          this.goodImgs[0].picUrl
        ];
        window.webkit.messageHandlers.sendFriend.postMessage(data);
      }
    },
    AndroidFriends() {
      let that = this;
      var ids = [{
                id: "weixin",
                ex: "WXSceneSession"
              }, {
                id: "weixin",
                ex: "WXSceneTimeline"
              }],
              bts = [{
                title: "发送给微信好友"
              }, {
                title: "分享到微信朋友圈"
              }];
           plus.nativeUI.actionSheet(
              {
                cancel: "取消",
                buttons: bts
              },
              function(e) {
                var i = e.index;
                if (i > 0) {
                  var id = ids[i - 1].id;
                  var ex = ids[i - 1].ex;
                  var s = null;
                  let shareParams = {
                    href:"http://wx.jumuc.com/#/gooddetail/" + that.goodsId,
                    title: that.good.goodsName,
                    content: that.good.goodsName,
                    thumbs: [
                      that.goodImgs[0].picUrl
                    ],
                    pictures: [
                      that.goodImgs[0].picUrl
                    ],
                    extra: {
                      scene: ex
                    }
                  };
                  if (!id || !(s = shares[id])) {
                    that.$toast("无效的分享服务！");
                    return;
                  }
                  if (s.authenticated) {
                    //已经授权
                    s.send(
                            shareParams,
                            function() {//分享成功
                              //判断是促销活动
                              if(that.promotions > 0) {
                                  that.forwardGetIntegral();
                              }else {
                                  that.shareGetIntegral();
                                  }
                            },
                            function(e) {
                              that.$toast("分享失败！");
                            }
                    );
                  } else {
                    //没有授权
                    s.authorize(
                            function() {
                              s.send(
                                      shareParams,
                                      function() {//分享成功
                                        //判断是促销活动
                                                            if(that.promotions > 0) {
                                                                that.forwardGetIntegral();
                                                            }else {
                                                                that.shareGetIntegral();
                                                            }
                                      },
                                      function(e) {
                                        that.$toast("分享失败！");
                                      }
                              );
                            },
                            function(e) {
                              that.$toast("微信认证授权失败！");
                            }
                    );
                  }
                }
              }
      );
    },

    sharedInfo() {
      let that = this;
      if (!navigator.userAgent.match(/android/i)) {
        that.show2 = true;
      }else{
        that.AndroidFriends();
      }

    },
    shareGetIntegral() {
      //分享成功的函数
      let that = this;
      that.$api.get(
        that.jumuc.integral.share,
        {
          userId: localStorage.getItem("userId"),
          source: 2
        },
        successRes => {
          if (successRes.success) {
            that.$toast("分享成功,您获得" + successRes.data.integral + "积分");
          } else {
            that.$toast(successRes.msg);
          }
        }
      );
    },
    shareFail() {
      //分享失败的函数
      this.$toast("分享失败");
    },
    back() {
      history.back();

      //location.href = "#/home"
    },
    callPhone() {
      //打电话
      let phoneNumber = "";
      if(localStorage.getItem("token")==""||localStorage.getItem("token")==null||localStorage.getItem("serviceTel")=="undefined"){//没登陆时
         phoneNumber=localStorage.getItem("phone");
      }else{
        phoneNumber =localStorage.getItem("serviceTel");
      }
      Dialog.confirm({
        title: "拨打电话",
        message: phoneNumber
      })
        .then(() => {
          window.location.href = "tel:" + phoneNumber;
        })
        .catch(() => {});
    },

    shoucang() {
      let that = this;
      this.goodsId = this.$route.params.goodsId;
      that.$api.post(
        this.jumuc.collect,
        { type: "goods", id: this.goodsId },
        successRes => {
          that.$toast(successRes.msg);
          if (successRes.success) {
            that.$toast(successRes.msg);
          } else {
            if (!localStorage.getItem("token") != null) {
              location.href = "#/login";
            }
          }
          if (successRes.data.isCollect == 1) {
            that.$refs.goods.style.color = "#d0021b";
          } else {
            that.$refs.goods.style.color = "#333";
          }
        }
      );
    },
    storeSel() {
      let that = this;
      this.storeId = that.store.id;
      that.$api.post(
        this.jumuc.collect,
        { type: "store", id: this.storeId },
        successRes => {
          that.$toast(successRes.msg);
          if (successRes.success) {
            that.$toast(successRes.msg);
          } else {
            if (!localStorage.getItem("token") != null) {
              location.href = "#/login";
            }
          }
          if (successRes.data.isCollect == 1) {
            that.$refs.store.style.color = "#d0021b";
          } else {
            that.$refs.store.style.color = "#888";
          }
        }
      );
    },
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
    scrollfixed() {
      $(".navbar-items a").click(function() {
        var _toId = $(this).attr("to");
        var _top = 0;
        if (_toId) {
          _top = $("#" + _toId).offset().top - 50;
        }
        $(document).scrollTop(_top);
        $(this)
          .addClass("active")
          .siblings()
          .removeClass("active");
      });
    },
    goodsEvaluation(id) {
      let that = this;
      for (var i = 0; i < that.evaluateTypeList.length; i++) {
        if (id == 0) {
          that.evaluateActive[0] = "active";
          that.evaluateActive[that.evaluateTypeList[i].id] = "";
        } else {
          that.evaluateActive[0] = "";
          if (id == that.evaluateTypeList[i].id) {
            that.evaluateActive[id] = "active";
          } else {
            that.evaluateActive[that.evaluateTypeList[i].id] = "";
          }
        }
      }
      this.$api.post(
        this.jumuc.goodsEvaluation,
        {
          goodsId: this.goodsId,
          currentPage: 1,
          evaluateTypeId: id == 0 ? null : id
        },
        successRes => {
          if (successRes.success) {
            that.commentList = successRes.data.commentList.list;
            that.total = successRes.data.commentList.total;
          }
        }
      );
    },
    goodsConsultSave() {
      //点击咨询
      let that = this;
      this.code = "";
      this.changeSrc();
      that.goodsConsult = true;
      that.goodsConsultContent = "";
    },
    cancalDialog(action) {

    },
    goodsConsultadd() {
      //咨询的确定
      let that = this;
      that.$api.post(
        that.jumuc.order.goodsConsultSave,
        {
          goodsId: that.goodsId,
          consultContent: that.goodsConsultContent,
          code: this.code
        },
        successRes => {
          if (successRes.success) {
            this.$toast(successRes.msg);
          } else {
            this.$toast(successRes.msg);
          }
        }
      );
    }
  },

  filters: {
    priceFmt(price) {
      if (localStorage.getItem("token") == null) {
        return "会员登录查看";
      } else if (price == null ||price==0) {
        return "已售罄";
      }
      return "￥ " + price;
    }
  }
};
</script>
<style lang="less" scoped>
@bule-thame: #3c6eeb;
#detail {
  margin-bottom: 50px!important;
}
.jump-gooddetail {
  &-header {
    position: fixed;
    top: env(safe-area-inset-top);
    left: 0px;
    width: 100%;
    background-color: @bule-thame;
    z-index: 9999;
    .navbar-items {
      padding: 5px 0;
      a {
        color: #f7f7f7;
        display: inline-block;
        margin: 0 10px;
        &.active {
          border-bottom: 1px solid #f7f7f7;
        }
      }
    }
  }

  .navbar-items {
    padding: 5px 0;
    a {
      color: #f7f7f7;
      display: inline-block;
      margin: 0 10px;
      &.active {
        border-bottom: 1px solid #f7f7f7;
      }
    }
  }

  &-navbar {
    &-arrow {
      line-height: 40px;
      text-align: center;
    }
    i {
      font-size: 20px;
      color: #ffffff;
      vertical-align: -5px;
    }
  }
  &-swipe {
    height: 300px;
    min-width: 100%;
    text-align: center;
    background-color: #fff;
    margin-bottom: 5px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .btn-cart {
    background-color: #f5a623;
    border-color: #f5a623;
  }
  .btn-buy {
    background-color: #f57c23;
    border-color: #f57c23;
  }
  .detail-header,
  .detail-active,
  .detail-comment,
  .detail-info,
  .detail-show {
    background-color: #fff;
    padding: 10px 15px;
    margin-bottom: 10px;

    h5 {
      font-size: 16px;
      color: #000;
      line-height: 150%;
    }
    img {
      width: 100% !important;
    }
  }

  .detail-comment,
  .detail-info,
  .detail-show {
    // padding: 20px 15px 15px;
    h5 {
      margin-bottom: 10px;
    }
  }
  .detail-info p span {
    display: inline-block;
    width: 60px;
  }
  .detail-header {
    h4 span {
      font-size: 18px;
      margin-right: 5px;
    }
    h4 {
      font-size: 24px;
      color: #d0021b;
    }
    .icon-shoucang {
      font-size: 24px;
    }
    i.detail-share {
      display: inline-block;
      margin-left: 5px;
      color: #666;
      font-size: 26px;
      vertical-align: -2px;
    }
  }
  p {
    padding: 2px 0 4px;
    font-size: 14px;
    color: #666;
    line-height: 150%;
    span,
    img {
      margin-right: 5px;
    }
  }
  p.comment-more {
    color: #f5a623;
    text-align: right;
  }
  p.comment-tag {
    line-height: 200%;
    padding: 10px 0;
    span {
      display: inline-block;
      border: 1px solid @bule-thame;
      padding: 0 10px;
      margin-right: 15px;
      margin-bottom: 15px;
      border-radius: 8px;
      color: @bule-thame;
      &.active {
        background-color: @bule-thame;
        color: #fff;
      }
    }
  }
  .comment-item {
    padding: 10px 0;
    border-bottom: 1px solid #eee;
  }
}

.van-goods-action-mini-btn {
  i {
    font-size: 18px;
    margin-bottom: 5px;
  }
}

.van-cell {
  padding: 0;
  .van-cell__title {
    width: 32px;
    max-width: 32px;
    margin-right: 5px;
  }
}

.van-popup {
  .activityContent {
    height: 400px;
    padding: 15px;
  }
}
// 电话与规格的样式
.phoneBox {
  position: fixed;
  padding-top: 6px;
  box-sizing: border-box;
  width: 64px;
  height: 64px;
  border-radius: 3px;
  top: 50%;
  transform: translateY(-27px);
  right: 10px;
  text-align: center;
  background: #766969;
  p {
    font-size: 12px !important;
    color: #fff !important;
  }
  .close {
    position: absolute;
    top: -20px;
    right: -10px;
  }
}
.attrBox {
  width: 100%;
  border-radius: 16px 16px 0 0;
  .titleBoxs {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #ccc;
    box-sizing: border-box;
    padding: 20px 10px 10px;
    .closeBox {
      width: 46px;
      height: 46px;
      position: absolute;
      top: 0px;
      right: 2px;
      text-align: center;
      font-size: 26px;
      color: #888;
      .icon {
        line-height: 46px;
      }
    }
    .imgCont {
      width: 90px;
      height: 90px;
      img {
        width: 100%;
      }
    }
    .sRight {
      flex: 1;
      p {
        font-size: 14px;
        color: #666;
      }
      .price {
        font-size: 18px;
        color: #d0021b;
        span {
          font-size: 24px;
        }
      }
    }
  }
  .sizeBox {
    width: 100%;
    box-sizing: border-box;
    padding: 14px;
    border-bottom: 1px solid #ccc;
    .item {
      width: 100%;
      h3 {
        font-size: 16px;
        color: #333;
        margin-bottom: 10px;
      }
      ul {
        width: 100%;
        overflow: hidden;
        margin-bottom: 14px;
        li {
          float: left;
          font-size: 14px;
          color: #333;
          border: 1px solid #f5f5f5;
          background-color: #f5f5f5;
          border-radius: 10px;
          padding: 5px 10px;
          margin: 0 14px 0 0;
        }
        .activeLi {
          border-color: #ff0036;
          color: #ff0036;
          background-color: #fff5f7;
        }
        .disLi {
          color: #cfcfcf;
          pointer-events: none;
           border: 1px solid #f5f5f5;
          background-color: #f5f5f5;
        }
      }
    }
  }
  .remarkCont{
     width: 100%;
    box-sizing: border-box;
    padding: 14px;
    border-bottom: 1px solid #ccc;
    p{
         overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    }
  }

  .countBox {
    width: 100%;
    box-sizing: border-box;
    padding: 14px 14px 10px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    .leftBox {
      width: 40%;
      h3 {
        color: #333;
        font-size: 16px;
      }
      span {
        margin-top: 10px;
        font-size: 14px;
        color: #ee0a24;
      }
    }
    .rightBox {
      width: 60%;
      text-align: right;
    }
  }
  .btns {
    padding: 4px 14px 14px;
    box-sizing: border-box;
    button {
      width: 100%;
      background-color: #f57c23;
      border-color: #f57c23;
    }
  }
  .btnT {
    padding: 4px 14px 14px;
    box-sizing: border-box;
    .btn2 {
      width: 50%;
      background-color: #f57c23;
      border-color: #f57c23;
      color: #fff;
      font-size: 16px;
    }
    .btn1 {
      width: 50%;
      background-color: #f5a623;
      border-color: #f5a623;
      color: #fff;
      font-size: 16px;
    }
  }
}
.guiBox {
  padding: 0 20px 20px;
  border-radius: 16px 16px 0 0;
  .closeBox {
    width: 46px;
    height: 46px;
    position: absolute;
    top: 0px;
    right: 2px;
    text-align: center;
    font-size: 26px;
    color: #888;
    .icon {
      line-height: 46px;
    }
  }
  h5 {
    text-align: center;
    margin: 20px 0 10px;
    font-size: 18px;
  }
  .can-item {
    padding: 10px 0;
    border-bottom: 1px solid #eee;
    font-size: 14px;
    .can-t {
      color: #888;
    }
    .can-v {
      color: #555;
    }
  }
}
.van-hairline--top-bottom {
  position: inherit !important;
}
</style>
<style lang="less">
.detail-show {
  img {
    width: 100%;
  }
}
</style>

